import * as React from 'react';
import { useState } from 'react';
import { Typography, Checkbox, FormControlLabel } from '@mui/material';
import TextField from '@mui/material/TextField';
import { AuthContext } from '../../../context/auth.context';
import theme from '../../../assets/theme/index';
import CustomCard from "../../../components/UIComponents/CustomCard"
import CustomBox from '../../../components/UIComponents/CustomBox';
import CustomButton from "../../../components/UIComponents/CustomButton"
import CustomTypography from "../../../components/UIComponents/CustomTypography"
import CustomTextField from "../../../components/UIComponents/CustomTextField"
import bgImage from "../../../assets/image/bg.png";
import LoginLogo from "../../../assets/image/login_logo.png";
import { fetchLogin } from '../../../service/network';
import { Margin } from '@mui/icons-material';
import { mt } from 'date-fns/locale';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function LoginScreen() {
    const { setLogin, setUserDoc, setRefreshToken } = React.useContext(AuthContext);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const login = () => {
        setIsLoading(true);
        fetchLogin(username, password).then((resp) => {
            setLogin(resp.data.token);
            setUserDoc(resp.data);
            setRefreshToken(resp.data.refresh);
            setIsLoading(false);
        }).catch((err) => {
            console.log(err);
            setIsLoading(false);
            setError("Username or Password is Incorrect");
        });
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            login();
        }
    };

    return (
        <CustomBox
            style={{
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100vw',
                minHeight: '100vh',
                padding: '16px', // Add padding to prevent edge sticking
                boxSizing: 'border-box',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CustomCard
                bgColor="primary"
                color="light"
                shadow="lg"
                padding={{ xs: 2, sm: 3, md: 6 }} // More responsive padding
                borderRadius="xxl" // Different radius for mobile
                sx={{
                    width: '100%',
                    maxWidth: '450px',
                    mx: 'auto', // Center horizontally
                    boxSizing: 'border-box',
                    paddingLeft:3,
                    paddingRight:3

                }}
            >

                <CustomBox textAlign="center">
                    <img
                        src={LoginLogo}
                        alt="Login Logo"
                        style={{
                            maxWidth: '100%',
                            width: '350px', // You can adjust this value as needed
                            height: 'auto',
                        }}
                    />
                </CustomBox>

                <CustomBox >
                    <CustomTypography
                        variant="Heading"
                        color="light"
                        gutterBottom
                        sx={{
                            ml: 2.5
                        }}>
                        Email:
                    </CustomTypography>
                    <CustomBox display="flex" flexDirection="column" gap={1} >
                        {/* Email Field */}


                        <CustomTextField
                            type="email"
                            placeholder="Enter Email ID"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            onKeyPress={handleKeyPress}
                            bgColor="primary"
                            color="light"
                            borderRadius="medium"
                            borderColor="light"
                            hoverEffect
                            fullWidth
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderWidth: '2px'
                                    },
                                    '&:hover fieldset': {
                                        borderWidth: '2px'
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderWidth: '2px'
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    '&:-webkit-autofill': {
                                        WebkitBoxShadow: `0 0 0 1000px ${theme.palette.primary.main} inset`,
                                        WebkitTextFillColor: theme.palette.light.main,
                                    },
                                },
                            }}
                        />
                    </CustomBox>


                    {/* Password Field */}
                    <CustomTypography
                        variant="Heading"
                        color="light"
                        mb="5px"
                        sx={{
                            ml: 2.5

                        }}
                    >
                        Password:
                    </CustomTypography>
                    <CustomBox >

                      <CustomTextField
    type={showPassword ? "text" : "password"}
    placeholder="Enter Password"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    onKeyPress={handleKeyPress}
    bgColor="primary"
    color="light"
    borderRadius="medium"
    borderColor="light"
    hoverEffect
    fullWidth
    InputProps={{
        endAdornment: (
            <InputAdornment position="end">
                <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    sx={{ color: "white" }}
                >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
            </InputAdornment>
        )
    }}
    sx={{
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderWidth: '2px'
            },
            '&:hover fieldset': {
                borderWidth: '2px'
            },
            '&.Mui-focused fieldset': {
                borderWidth: '2px'
            },
        },
    }}
/>

                    </CustomBox>



                    {/* Error Message */}
                    {error && (
                        <CustomBox textAlign="center">
                            <Typography variant="bodyText1" color="error.main">
                                {error}
                            </Typography>
                        </CustomBox>
                    )}

                    {/* Login Button */}
                    <CustomBox textAlign="center">
                        <CustomButton
                            fullWidth
                            loading={isLoading}
                            onClick={login}
                            bgColor="light"
                            color="primary"
                            borderRadius="10px"
                            sx={{
                                maxWidth: '200px',
                                height: "40px"
                            }}
                        >
                            <CustomTypography
                                variant="buttonL"
                                textAlign="center"
                                sx={{ textTransform: 'none' }}
                            >
                                Login
                            </CustomTypography>

                        </CustomButton>
                    </CustomBox>

                    {/* Forgot Password */}
                    <CustomBox textAlign="center">
                        <CustomTypography
                            variant="bodyText1"
                            color="light"
                            sx={{
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                '&:hover': {
                                    opacity: 0.8
                                }
                            }}
                            onClick={() => alert('Please contact your admin')}
                        >
                            Forgot your password?
                        </CustomTypography>
                    </CustomBox>
                </CustomBox>
            </CustomCard>
        </CustomBox>
    );
}